module.exports = __webpack_public_path__ + "static/media/boy.eae74d36.svg";